import React from "react";
import Select from "react-select";
import ic_filter from "./../../../assets/ic_filter.svg";
import ic_360degree_view from "./../../../assets/ic_360degree_view.svg";
import select_arrow_down from "./../../../assets/select_arrow_down.svg";
import Checkbox from "../../../common/Checkbox/Checkbox";
import {useEffect,useRef } from "react";
import { toast } from "react-toastify";
import { useState } from "react";
//import api from "../../utils/api";
import api from "../../../utils/api";
import { ExportCSV } from "./ExportCSV";



export default function  FacilitatorFilterSection(props)
{
    

    return (
        <>
            <div className="col-12 lpm-filter-section conv-pl40 conv-pr40 conv-fixeds-headerss">
                <div className="row conv-mt20">
                    <div className="col-3">
                        <button className="lpm-con-btn-filled conv-pl15 conv-pr15 conv-font14"
                            onClick={(e)=>{ props.toggleFilterModal()}} >
                            <img
                                alt=""
                                src={ic_filter}
                                height={"15px"}
                                width={"15px"}
                                className="conv-mr10"
                            />
                            Filter By
                        </button>
                        <button className="lpm-con-btn-filled conv-pl15 conv-pr15 conv-font14 conv-ml25"
                            onClick={(e)=>{ props.toggleEngagementFiltersModal()}} >
                            Engagement
                        </button>
                    </div>
                    <div className="col-5">
                        <input
                            type="text"
                            className="conv-float-left form-control conv-h250rem search-input "
                            placeholder="Search"
                            onChange={props.onCustomerFilterValueChange}
                            onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                    props.onSearchClicked();
                                }
                            }}
                            //autoComplete={false}
                            value={props.customerFilterValue}
                            name="searchTerm"
                        />
                        <button 
                            className="lpm-con-btn-bordered conv-float-left conv-font14 conv-pl15 conv-pr15 con-br0"
                            onClick={props.onSearchClicked}>
                            Search
                        </button>
                        <button 
                            type="button" 
                            className="spm-con-btn-bordered-filter conv-float-left conv-ml25 conv-pr25 conv-pl25"
                            onClick={(e) =>props.onClearAllClicked(e)}>
                            Clear All
                        </button>  

                    </div>
                    <div className="col-4">


                        <a className="conv-float-right con-cursor-pointer"
                           href="/home/three-sixty-degree-view-new/"target="_blank">
                            <img
                                alt=""
                                src={ic_360degree_view}
                                height={"15px"}
                                width={"21px"}
                                className="conv-mr10"
                            />
                            <span className="link360-view-text">
                                360 Degree View
                            </span>
                        </a>

                        <a className="conv-float-right con-cursor-pointer conv-mr20"
                           href="/home/facilitator-actions-view-container/"target="_blank">                            
                            <span className="link360-view-text">
                                Manage Followup
                            </span>
                        </a>

                        {/* <button className="lpm-con-btn-filled conv-pl15 conv-pr15 conv-font14 conv-ml25"
                            onClick={(e)=>props.fetchAuditLogReport(e)} >
                            Download
                        </button> */}                         

                        {/* <ExportCSV csvData={props.data} fileName={"myservices"} /> */}
                        
                    </div>
                </div>
            </div>
        </>
    )
}